import { useMemo } from 'react';

import { getCompanyEffortsData } from 'src/utils/effortsUtils';

/**
 * Custom hook for filtering and organizing efforts data for Reports components
 * Handles both wins and in-progress efforts with proper sorting and memoization
 */
export const useEffortsFiltering = (queriesByExpert, externalEfforts) => {
  // Memoize the filtered data to prevent unnecessary recalculations
  const { winsData, effortsData } = useMemo(() => getCompanyEffortsData(queriesByExpert, externalEfforts), [queriesByExpert, externalEfforts]);

  return {
    winsData,
    effortsData,
  };
};
